import {Pipe, PipeTransform} from '@angular/core';
import {AvReferenzNummerListEntry} from "../../../core/av-api";
import {FormatGeschaeftsnummerPipe} from "./format-geschaeftsnummer.pipe";
import {TranslateNamePipe} from "../simple/translate-name.pipe";

@Pipe({
  name: 'formatAvReferenznummer'
})
export class FormatAvReferenzNummerPipe implements PipeTransform {

  constructor(private formatGeschaeftsnummer: FormatGeschaeftsnummerPipe, private translateName: TranslateNamePipe) {
  }

  transform(nummer: AvReferenzNummerListEntry): string {
    if (!nummer || !nummer.geometergeschaeftsnummerEntry) {
      return '';
    }
    let val = '';
    if (nummer.gbGemeinde && nummer.gbGemeinde.name) {
      val += this.translateName.transform(nummer.gbGemeinde.name);
      if (nummer.gbGemeinde.bfsNummer) {
        val += " (" + nummer.gbGemeinde.bfsNummer + ') ';
      }
    }
    val += this.formatGeschaeftsnummer.transform(nummer.geometergeschaeftsnummerEntry);
    return val;
  }
}
